var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Activities',{attrs:{"title":"Members","items":_vm.result}})
}
var staticRenderFns = []

export { render, staticRenderFns }